export default __webpack_public_path__ + "static/media/termo-consentimento-hemocue.04bdcb31.pdf";